import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';

import messages from './tabsMessages';

import './PaginationTabs.scss';

const PaginationTabs = ({ page, total, ...props }) => (
  <div
    className="navigation-tabs pagination-tabs"
    style={{ display: props.hidePages ? 'none' : 'flex' }}
  >
    <FormattedMessage {...messages.previous}>
      {txt => (
        <a
          className={`nav-tabs-button ${total > 1 && page > 1 ? 'active' : ''}`}
          title={txt}
          onClick={props.onPrevious}
          tabIndex="0"
        >
          <i className="nt-icon ti-angle-left" />
        </a>
      )}
    </FormattedMessage>
    <div>
      <FormattedMessage {...messages.page} /> {page} <FormattedMessage {...messages.of} />{' '}
      {total === 0 ? total + 1 : total}
    </div>
    <FormattedMessage {...messages.next}>
      {txt => (
        <a
          className={`nav-tabs-button ${page < total ? 'active' : ''}`}
          title={txt}
          onClick={props.onNext}
          tabIndex="0"
        >
          <i className="nt-icon ti-angle-right" />
        </a>
      )}
    </FormattedMessage>
  </div>
);

PaginationTabs.propTypes = {
  onNext: PropTypes.func,
  onPrevious: PropTypes.func,
  page: PropTypes.number,
  total: PropTypes.number,
};

PaginationTabs.defaultProps = {
  onNext: undefined,
  onPrevious: undefined,
  page: 1,
  total: 1,
};

export default PaginationTabs;
